<template>
  <div class="search-error">
    <div class="content-panel panel">
      <vb-icon name="info" :size="24" />
      <h6 class="search-error--heading">
        Si è verificato un problema temporaneo.
      </h6>
      <p class="search-error--text">Ti invitiamo a ripetere la ricerca.</p>
      <vb-button
        :vb_options="{ size: 'md', variant: 'info' }"
        @click="$emit('retry')"
      >
        Riprova
      </vb-button>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'search-error',
  };
</script>

<style lang="scss" scoped>
  .search-error {
    text-align: center;
    margin-bottom: $grid-gutter-width;
    .panel {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 10px;
      padding: $grid-gutter-width $grid-gutter-width;
    }
    &--heading {
      @extend .h6 !optional;
      margin-bottom: 0;
    }
    &--text {
      font-size: 12px;
      margin-bottom: 0;
    }
  }
</style>
